export default __webpack_public_path__ + "static/6-de494fe29b5460c7e93945e997fe18b0.png";